/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Number of significand bits for a half-precision floating-point number.
*
* @module @stdlib/constants-float16-num-significand-bits
* @type {integer16}
*
* @example
* var FLOAT16_NUM_SIGNIFICAND_BITS = require( '@stdlib/constants-float16-num-significand-bits' );
* // returns 10
*/


// MAIN //

/**
* Number of significand bits for a half-precision floating-point number.
*
* @constant
* @type {integer16}
* @default 10
*/
var FLOAT16_NUM_SIGNIFICAND_BITS = 10|0;


// EXPORTS //

module.exports = FLOAT16_NUM_SIGNIFICAND_BITS;
